// Chapter 3: the students list, adding a student field by field, the student
// card, and the parent registration link. Deletes and link rotation only open
// their confirmation, which the guide cancels.
//
// The new student's ID number must pass the form's checksum, so it is the
// obviously fictional 000000018 (no real person has it); every other demo ID
// in demoData.js fails the checksum on purpose.
const students = {
  id: "journey-students",
  title: "الطلاب",
  route: "/students",
  requires: "students.view",
  steps: [
    {
      target: "students-search",
      mood: "point",
      title: "البحث",
      body: "اكتب اسم الطالب أو هويته لفلترة القائمة.",
    },
    {
      target: "students-status-filter",
      requires: "students.viewAll",
      mood: "point",
      title: "حالة الطالب",
      body: "في «فلتر» تبدّل بين الطلاب الفعّالين، وبانتظار الموافقة، وغير الفعّالين.",
    },
    {
      target: "students-table",
      mood: "point",
      title: "قائمة الطلاب",
      body: "كل صف طالب، ومعه أزرار فتح بطاقته وتنزيل ملفه.",
    },
    {
      target: "students-add",
      requires: "students.create",
      mood: "point",
      title: "إضافة طالب",
      body: "سأفتح نموذج طالب جديد وأملؤه أمامك.",
      action: { type: "click", target: "students-add" },
    },
    {
      target: "student-tz",
      requires: "students.create",
      mood: "explain",
      title: "رقم الهوية",
      body: "أبدأ برقم الهوية، ويتحقق النظام منه.",
      action: { type: "type", target: "student-tz", value: "000000018" },
    },
    {
      target: "student-firstname",
      requires: "students.create",
      mood: "explain",
      title: "الاسم الشخصي",
      body: "أكتب الاسم الشخصي للطالب.",
      action: { type: "type", target: "student-firstname", value: "مازن" },
    },
    {
      target: "student-lastname",
      requires: "students.create",
      mood: "explain",
      title: "اسم العائلة",
      body: "ثم اسم العائلة.",
      action: { type: "type", target: "student-lastname", value: "التجريبي" },
    },
    {
      target: "student-birth-date",
      requires: "students.create",
      mood: "explain",
      title: "تاريخ الميلاد",
      body: "أختار تاريخ الميلاد، وهو حقل مطلوب.",
      action: { type: "type", target: "student-birth-date", value: "2014-09-01" },
    },
    {
      target: "student-gender",
      requires: "students.create",
      mood: "explain",
      title: "الجنس",
      body: "أختار الجنس من القائمة.",
      action: { type: "select", target: "student-gender", value: "ذكر" },
    },
    {
      target: "student-street",
      requires: "students.create",
      mood: "explain",
      title: "السكن",
      body: "المدينة معبّأة مسبقًا، فأكتب الشارع فقط.",
      action: { type: "type", target: "student-street", value: "شارع التدريب" },
    },
    {
      target: "student-school",
      requires: "students.create",
      mood: "explain",
      title: "المدرسة",
      body: "أكتب مدرسة الطالب.",
      action: { type: "type", target: "student-school", value: "مدرسة تجريبية" },
    },
    {
      target: "student-layer",
      requires: "students.create",
      mood: "explain",
      title: "الصف",
      body: "ثم صفّه الدراسي، وبقية البيانات اختيارية.",
      action: { type: "type", target: "student-layer", value: "السادس" },
    },
    {
      target: "student-save",
      requires: "students.create",
      mood: "point",
      title: "حفظ الطالب",
      body: "سأضغط «إضافة الطالب»، فيطلب النظام التأكيد.",
      action: { type: "click", target: "student-save" },
    },
    {
      target: "confirm-ok",
      requires: "students.create",
      mood: "point",
      title: "تأكيد الإنشاء",
      body: "سأضغط «نعم»، فتظهر رسالة نجاح.",
      action: { type: "click", target: "confirm-ok" },
    },
    {
      target: "students-open",
      mood: "point",
      title: "بطاقة الطالب",
      body: "سأفتح بطاقة طالب لترى بياناته كاملة.",
      action: { type: "click", target: "students-open" },
    },
    {
      // On a phone the card opens the student's read-only page; the form is
      // behind «تعديل». Skipped on its own where the click already opened the form.
      target: "student-view-edit",
      requires: "students.edit",
      mood: "point",
      title: "تعديل الطالب",
      body: "هذه صفحة الطالب. سأضغط «تعديل» لفتح بطاقته كاملة.",
      action: { type: "click", target: "student-view-edit" },
    },
    {
      target: "student-details",
      requires: "students.edit",
      mood: "point",
      title: "بيانات الطالب",
      body: "الاسم وتاريخ الميلاد والجنس، ورقم الهوية ثابت.",
    },
    {
      target: "student-parents",
      requires: "students.edit",
      mood: "point",
      title: "بيانات الأهل",
      body: "اختيارية، لكنها تساعد على التواصل السريع مع الأهل.",
    },
    {
      target: "student-health",
      requires: "students.edit",
      mood: "point",
      title: "الصحة والملاحظات",
      body: "هنا يُسجَّل ما يلزم المرشد معرفته عن صحة الطالب.",
    },
    {
      target: "student-delete",
      requires: "students.delete",
      mood: "warn",
      title: "حذف الطالب",
      body: "الحذف نهائي، وسأعرض نافذة التأكيد فقط.",
      action: { type: "click", target: "student-delete" },
    },
    {
      target: "confirm-cancel",
      requires: "students.delete",
      mood: "explain",
      title: "إلغاء الحذف",
      body: "سأضغط «إلغاء» فلا يُحذف شيء.",
      action: { type: "cancelConfirm" },
    },
    {
      target: "student-back",
      mood: "point",
      title: "العودة إلى القائمة",
      body: "سأعود الآن إلى قائمة الطلاب.",
      action: { type: "click", target: "student-back" },
    },
    {
      target: "students-parent-link",
      requires: "students.parentLink",
      mood: "point",
      title: "رابط تسجيل الأهل",
      body: "سأفتح لك نافذة رابط تسجيل الأهل.",
      action: { type: "click", target: "students-parent-link" },
    },
    {
      target: "parent-link-dialog",
      requires: "students.parentLink",
      mood: "explain",
      title: "الرابط الثابت",
      body: "الرابط الثابت يُرسل للأهل، وطلبهم يظهر في الانتظار.",
    },
    {
      target: "parent-link-copy",
      requires: "students.parentLink",
      mood: "point",
      title: "نسخ الرابط",
      body: "«نسخ» ينسخ الرابط لتلصقه في رسالة.",
    },
    {
      target: "parent-link-usage",
      requires: "students.parentLink",
      mood: "point",
      title: "عدد الطلبات",
      body: "عدد الطلبات آخر سبعة أيام، وللرابط حدّ أقصى.",
    },
    {
      target: "parent-link-rotate",
      requires: "students.parentLink",
      mood: "warn",
      title: "تغيير الرابط",
      body: "تغيير الرابط يوقف القديم، وسأعرض التأكيد فقط.",
      action: { type: "click", target: "parent-link-rotate" },
    },
    {
      target: "confirm-cancel",
      requires: "students.parentLink",
      mood: "explain",
      title: "إلغاء التغيير",
      body: "سأضغط «إلغاء» فيبقى الرابط كما هو.",
      action: { type: "cancelConfirm" },
    },
    {
      target: "parent-link-close",
      requires: "students.parentLink",
      mood: "point",
      title: "إغلاق النافذة",
      body: "سأغلق النافذة وأعود إلى قائمة الطلاب.",
      action: { type: "click", target: "parent-link-close" },
    },
  ],
};

export default students;
